module.exports = __webpack_public_path__ + "img/play-store.ce7b7861.svg";